import request from '@/api/request'

/**
 * 获取租户列表
 */
export const getAvailableCompanyList = (data) => {
  return request({
    url: "base/adm/company/getAvailableCompanyList",
    method: "post",
    data,
  });
};
